import { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

import { AppHeader } from "../../components/header/header";
import { LoadingIndicator } from "../../components/utilities/loader";
import { useAuth } from "../../services/authentication/authentication.context";
import { PillInputBox } from "../../components/forms/form-inputs";
import { AppAlert } from "../../components/utilities/app-alert";

import { useLesson } from "../../services/lessons/lessons.context";
import { LargeTextBox } from "../../components/forms/textarea";
import { PillDropdown } from "../../components/forms/dropdown-select";
import { AppFooter } from "../../components/footer/footer";

export const CourseAddPage = () => {

    const { isLoading, token } = useAuth();
    const { loading, createNewCourse, loadCategories } = useLesson();

    const [lessonData, setLessonData] = useState();
    const [onAlert, setOnAlert] = useState();
    const [filePrev, setFilePrev] = useState();
    const [categories, setCategories] = useState();

    const fileRef = useRef();

    const handleSetValue = (e) => {
        setLessonData((data) => ({
            ...data,
            [e.target.name]: e.target.value
        }))
    }


     const uploadFile = (e) => {
        if (e.target.files[0].type.split("/")[0].toLowerCase() !== "image") {
            setOnAlert({
                caption: "Error!",
                message: "Invalid file format! Please upload a file of type image",
                accept: "Ok",
                onAccept: () => setOnAlert()
            })
            return;
        }
        setFilePrev(URL.createObjectURL(e.target.files[0]));
        setLessonData((d) => ({...d, documentFile: e.target.files[0]}));
    }


   
    const handleSubmit = async (e) => {
        e.preventDefault();
        const resp = await createNewCourse(lessonData, token);
        setOnAlert({
            caption: "Success!",
            message: resp.message,
            accept: "Ok",
            onAccept: () => setOnAlert()
        })

        //console.log(lessonData);
    }

    useEffect(() => {
        (async() => {
            const data = await loadCategories();
            setCategories(data);
        })();
    },[])


    return (
        <div className="min-v">
            <AppHeader />
            {(isLoading || loading) && <LoadingIndicator />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    onAccept={onAlert.onAccept}
                    closeAlert={() => setOnAlert()}
                />
            )}
            <div className="flx-cnt-pg">
                <div className={classNames("cap","lg-txt")}>Add a new Course</div>
                <div className="sm-sp" />
                <form className="add-form" onSubmit={(e) => handleSubmit(e)}>
                    <PillInputBox
                        type={"text"}
                        name={"title"}
                        caption={"Course title"}
                        onChange={(e) => handleSetValue(e) }
                    />
                    <PillInputBox
                        type={"text"}
                        name={"instructor"}
                        caption={"Course Instructor"}
                        onChange={(e) => handleSetValue(e) }
                    />
                    <div className="pill-input-box">
                        <select className="form-select"
                            name={'categoryId'}
                            onChange={(e) => handleSetValue(e)}
                        >
                            <option value={null}  defaultValue={null}>{'Select a category'}</option>
                            {categories?.map((cat, indx) => (
                                <option value={cat._id} key={indx}>{cat.title}</option>
                            ))}
                        </select>
                    </div>
                    <LargeTextBox
                        name={"slogan"}
                        placeholder={"Say something about the course"}
                        onChange={(e) => handleSetValue(e)}
                    />
                    {filePrev && (
                        <div className="video-prev-box">
                            < img src={filePrev} width={250} />
                        </div>
                    )}
                    <button 
                        className="sel-click"
                        onClick={(e) => {
                            e.preventDefault();
                            fileRef.current.click();
                        }}
                    > Select a poster for the course
                    </button>
                    <input 
                        type="file" 
                        name="avatar"  
                        onChange={(e) => uploadFile(e)}
                        className="file-sel"
                        ref={fileRef}
                    />
                    
                    <button 
                        className={classNames("form-button",'pill-input-box')}
                    >
                        Submit
                    </button>
                </form>
            </div>
            <AppFooter />
        </div>
    )
}